import { TableHead, TableHeader, TableRow } from '@/components/ui';
import { TableHeadSortable } from '@/components/custom';
import { IAccountingUser } from '@/interfaces';
import { nameof } from '@/functions';

export const DataTableHeader = () => (
    <TableHeader>
        <TableRow>
            <TableHead className='w-auto'>

            </TableHead>
            <TableHeadSortable
                className='w-auto'
                name={nameof<IAccountingUser>('name')}
                text='Nom' />
            <TableHeadSortable
                className='w-auto'
                name={nameof<IAccountingUser>('role')}
                text='Rôle' />
            <TableHead className='w-auto'>
                Salaire / %
            </TableHead>
            <TableHeadSortable
                className='w-auto'
                name={nameof<IAccountingUser>('type')}
                text='Type' />
            <TableHeadSortable
                className='w-44'
                name={nameof<IAccountingUser>('createdAt')}
                text='Date de création' />
            <TableHead className='w-12 text-right py-1'>
                Actions
            </TableHead>
        </TableRow>
    </TableHeader>
);

export default DataTableHeader;
